/* eslint-disable @typescript-eslint/camelcase */
import firebase from "firebase/app";
import amplitude from "amplitude-js";
import { reactive, readonly } from "vue";

const remoteConfig = firebase.remoteConfig();

/** The reactive state of this module */
const _state = reactive({ activated: false });

if (process.env.NODE_ENV === "development") {
  remoteConfig.settings.minimumFetchIntervalMillis = 60000; // 1 minute
}
remoteConfig.settings.fetchTimeoutMillis = 5000; // 5 seconds

remoteConfig.defaultConfig = {
  landing_page_copy: `{
    "variation":"DEFAULT",
    "header":"A better way to collaborate",
    "subheader":"End the back and forth. With time-coded comments, auto-versioning, and playback sync, Samply allows you to focus on creating.",
    "secondary_header":"Your workflow accelerated",
    "primary_cta":"Get started",
    "secondary_cta":"Let's go"
  }`
};

remoteConfig
  .fetchAndActivate()
  .then(() => {
    _state.activated = true;
    // Record experiments
    const identify = new amplitude.Identify();
    const landingPage = JSON.parse(remoteConfig.getString("landing_page_copy"));
    identify.set("exp_landing_page_copy", landingPage.variation);
    amplitude.getInstance().identify(identify);
  })
  .catch(e => console.error(e));

export const state = readonly(_state);
